import { formatXOF } from "@/lib/format";

/** Porté à l'identique depuis apps/web/components/ui/PriceTag.tsx (aucune dépendance Next.js dans l'original). */
export interface PriceTagProps {
  /** Prix courant, en francs CFA (XOF n'a pas de décimale). */
  amountMinor: number;
  /** Prix barré optionnel ; affiché seulement s'il est strictement supérieur au prix courant. */
  compareAtAmountMinor?: number | null;
  className?: string;
}

/** Affiche le prix courant + prix barré optionnel (VVS_MODELE_INTERFACE.md §0.3). */
export function PriceTag({ amountMinor, compareAtAmountMinor, className = "" }: PriceTagProps) {
  const hasDiscount = typeof compareAtAmountMinor === "number" && compareAtAmountMinor > amountMinor;

  return (
    <p className={["flex items-baseline gap-2 font-body", className].join(" ")}>
      <span className="text-lg font-semibold text-ink">{formatXOF(amountMinor)}</span>
      {hasDiscount ? (
        <span className="text-sm text-muted line-through">{formatXOF(compareAtAmountMinor as number)}</span>
      ) : null}
    </p>
  );
}
